// extracted by mini-css-extract-plugin
module.exports = {"icon":"CasinoGameModals_icon__gc6nT","wrapper":"CasinoGameModals_wrapper__3W6bP"};